import { useState } from 'react';
import { confirmable, createConfirmation, ReactConfirmProps } from "react-confirm";
import { Box, Button, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import ThemedDialog from "../Components/ThemedDialog";

interface Props extends AskForTextAnswerOptions, ReactConfirmProps<string> {
	show : boolean
}

const AskForTextAnswerDialog = (props : Props) => {
	const [text, setText] = useState<string>(props.text);

	const handleClose = () => {
		props.cancel();
	};

	return (
		<ThemedDialog open={props.show} maxWidth="sm" fullWidth onClose={handleClose}>
			<DialogTitle>
				{props.title}
			</DialogTitle>
			<DialogContent>
				<Box mb={2}>
					<TextField
						fullWidth
						variant="standard"
						value={text}
						label={props.label}
						onChange={(e) => setText(e.target.value)}
					/>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button
					variant="outlined"
					color="secondary"
					onClick={handleClose}
				>
					Abbrechen
				</Button>
				<Button
					variant="outlined"
					color="primary"
					href=""
					disabled={props.required ? !text : false}
					onClick={() => props.proceed(text)}
				>
					Ok
				</Button>
			</DialogActions>
		</ThemedDialog>
	);
};

interface AskForTextAnswerOptions {
	text : string
	title : string
	label : string
	required : boolean
}

const askForTextAnswer = (options : AskForTextAnswerOptions) => {
	const dialog = confirmable(props => <AskForTextAnswerDialog {...props} {...options} />);
	return createConfirmation<string>(dialog)();
};

export default askForTextAnswer;
